import type { ReactNode } from 'react'

type HomepageSectionHeaderProps = {
  eyebrow?: string
  title: string
  intro?: string
  cta?: ReactNode
}

export default function HomepageSectionHeader({
  eyebrow,
  title,
  intro,
  cta,
}: HomepageSectionHeaderProps) {
  const hasIntro = Boolean(intro)
  const className = [
    'sectionHeader',
    cta ? '' : 'sectionHeader--noCta',
    hasIntro ? '' : 'sectionHeader--bodyless',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={className}>
      <div className="sectionHeader-main">
        <div className="sectionHeader-title">
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h2>{title}</h2>
        </div>
        {hasIntro && (
          <div className="sectionHeader-body">
            <p>{intro}</p>
          </div>
        )}
      </div>
      {cta && <div className="sectionHeader-cta">{cta}</div>}
    </div>
  )
}
